import React from 'react';
import PropTypes from 'prop-types';
import { withTheme } from 'styled-components';
import { Button } from '@pearsontechnology/aero-components';
import { intl } from 'containers/LanguageProvider/IntlGlobalProvider';
import Modal, { ModalContent, ModalBodyText, ModalActions } from 'components/Modal';
import messages from './messages';

/**
 * A confirmation dialog warning users that they are about to delete a
 * KnowledgeMap
 * @param {*} props
 */
function KnowledgeMapDeleteConfirm({
  onDismiss, 
  handleActivityDelete,
  isDeleteDocumentItemConfirm,
  itemToDeleteHasChildren,
  toBeDeletedDocumentName, 
  theme, 
  ...props
}) {
  
  const itemDeleteTitle = itemToDeleteHasChildren ? intl.formatMessage(messages.modalConfirmationItemParentTitle) : 
    intl.formatMessage(messages.modalConfirmationItemChildTitle);

  const titleMessage = isDeleteDocumentItemConfirm ? itemDeleteTitle :
    intl.formatMessage(messages.modalConfirmationTitle, { toBeDeletedDocumentName });

  return (
    <Modal
      title={titleMessage}
      onDismiss={onDismiss}
      icon='warningCircle'
      iconColor={theme['color.redLight']}
      {...props}
    >
      <ModalContent>
        <ModalBodyText>
          {isDeleteDocumentItemConfirm ? intl.formatMessage(messages.modalConfirmationDescriptionItem) : 
            intl.formatMessage(messages.modalConfirmationDescription)}
        </ModalBodyText>
      </ModalContent>
      <ModalActions>
        <Button grey onClick={onDismiss}>
          {intl.formatMessage(messages.cancel)}
        </Button>
        <Button primary color={theme['color.redDark']} onClick={handleActivityDelete}>
          {intl.formatMessage(messages.delete)}
        </Button>
      </ModalActions>
    </Modal>
  );
}

KnowledgeMapDeleteConfirm.propTypes = {
  /* callback function fired if dialog is dismissed */
  onDismiss: PropTypes.func,
  /* callback for when the user confirms the deletion */
  handleActivityDelete: PropTypes.func,
  /* styled-components theme */
  theme: PropTypes.object,
  isDeleteDocumentItemConfirm: PropTypes.bool,
  itemTodeleteHasChildren: PropTypes.bool,
};

export default withTheme(KnowledgeMapDeleteConfirm);
